<app-simple-modal-header
	[pageTitle]="pageTitle"
	(dismissed)="dismiss()"
	*ngIf="inventoryItem"
>
	<app-inventory-modal-header
		[inventoryItem]="inventoryItem"
	></app-inventory-modal-header>
</app-simple-modal-header>

<ion-content *ngIf="inventoryItem">
	<form [formGroup]="form" *ngIf="form">
		<ion-list lines="full" *ngIf="dynamicAttributes">
			<ion-item
				*ngFor="let attribute of dynamicAttributes; index as index"
			>
				<ion-label position="stacked" class="bold">
					{{ attribute.attribute
					}}<ion-text *ngIf="attribute.isRequired" color="danger"
						>*</ion-text
					>
				</ion-label>
				<ion-input
					*ngIf="attribute.dataType == 'int'"
					(keypress)="inventoryFormHelper.preventNonInteger($event)"
					type="number"
					[formControl]="form.controls[index]"
				></ion-input>
				<ion-input
					*ngIf="attribute.dataType == 'char'"
					(keypress)="
						inventoryFormHelper.preventNonAlphaCharacter($event)
					"
					[formControl]="form.controls[index]"
				></ion-input>
				<ion-input
					*ngIf="attribute.dataType == 'varchar'"
					[formControl]="form.controls[index]"
				></ion-input>
				<ion-input
					*ngIf="attribute.dataType == 'money'"
					type="tel"
					(keypress)="inventoryFormHelper.preventNonCurrency($event)"
					(ionBlur)="inventoryFormHelper.formatMoneyInput($event)"
					[formControl]="form.controls[index]"
				></ion-input>
				<ion-input *ngIf="attribute.dataType == 'datetime'"
						   [formControl]="form.controls[index]"
						   id="editInventoryOpenCalendar{{index}}"
						   readonly="true"></ion-input>
				<ion-popover trigger="editInventoryOpenCalendar{{index}}" show-backdrop="true">
					<ng-template>
						<ion-datetime [showDefaultButtons]="true"
										[value]="inventoryFormHelper.toDateTimeString(form.controls[index].value)"
										(ionChange)="form.controls[index].setValue(inventoryFormHelper.toInventoryDateString($event.target.value))"></ion-datetime>
					</ng-template>
				</ion-popover>
				<ion-select
					*ngIf="attribute.dataType == 'boolean'"
					[formControl]="form.controls[index]"
				>
					<ion-select-option [value]="''"></ion-select-option>
					<ion-select-option [value]="'No'">No</ion-select-option>
					<ion-select-option [value]="'Yes'">Yes</ion-select-option>
				</ion-select>
				<ion-select
					*ngIf="attribute.dataType == 'customerservice'"
					[compareWith]="inventoryFormHelper.serviceCompareWith"
					[formControl]="form.controls[index]"
				>
					<ion-select-option [value]="''"></ion-select-option>
					<ion-select-option
						*ngFor="let service of serviceOptions"
						[value]="service.id"
					>
						{{ service.desc }}
					</ion-select-option>
				</ion-select>
			</ion-item>
		</ion-list>
	</form>
</ion-content>

<ion-footer>
	<ion-button expand="full" class="modal__submit" (click)="onSaveInventory()">
		Save Inventory
	</ion-button>
</ion-footer>
